// extracted by mini-css-extract-plugin
module.exports = {"footerCatalog":"catalog_footerCatalog__p7O5J","list":"catalog_list__yZyUX","expandable":"catalog_expandable__HHG5C","item":"catalog_item__fuY0A","accent":"catalog_accent__N1aef"};